import { render, staticRenderFns } from "./AccessControlOverview.vue?vue&type=template&id=3513092e&"
import script from "./AccessControlOverview.vue?vue&type=script&lang=js&"
export * from "./AccessControlOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports